import { createStyles, FullToken } from 'antd-style'

export const useStyles = createStyles(
  (
    { token },
    props: {
      size?: number
      weight?: number
      color?: keyof FullToken
      importantSetColor?: boolean
    }
  ) => ({
    text: {
      fontSize: `${props.size || 14}px`,
      fontWeight: `${props.weight || 400}`,
      color:
        props?.color &&
        (((token[props?.color] || token.colorTextBase) +
          (props.importantSetColor ? '!important' : '')) as string)
    }
  })
)
